module.exports = __webpack_public_path__ + "img/portugal-endocrine-nutritional-metabolic-diseases-female.853cd9f4.png";